import { createSlice } from "@reduxjs/toolkit";
import {
  getSalesSummaryCards,
  getSalesReferralLinkDetails,
  addSalesReferralLinkDetailsForLanguage,
  getSalesNetworkChart,
  getSalesRebateDetails,
} from "./thunk";

export const initialState = {
  // Get Summary Cards
  salesSummaryCardsData: [],
  salesSummaryCardsError: {},
  // Get Referral Link Details
  salesReferralLinkDetailsData: [],
  salesReferralLinkDetailsError: {},
  // Add Sales Referral Link Details For Language
  addSalesReferralLinkDetailsForLanguageData: [],
  addSalesReferralLinkDetailsForLanguageError: {},
  isSalesReferralLinkDetailsForLanguageSuccess: false,
  // Get Sales Network Info
  getSalesNetworkChartData: [],
  getSalesNetworkChartError: {},
  // Get Sales Rebate Details
  rebateSalesDetailsData: [],
  rebateSalesDetailsError: {},

  // // Post IB Onboarding Personal Info
  // addIBOnboardingPersonalInfoData: [],
  // addIBOnboardingPersonalInfoError: {},
  // // Post IB Onboarding Identity Verification
  // addIBOnboardingIdentityVerifyData: [],
  // addIBOnboardingIdentityVerifyError: {},
  // // Post IB Onboarding Address Verification
  // addIBOnboardingAddressVerifyData: [],
  // addIBOnboardingAddressVerifyError: {},
  // // Get Country List
  // getCountryListData: [],
  // getCountryListError: {},
  // // Get Country List Int2
  // getCountryListInt2Data: [],
  // getCountryListInt2Error: {},
  // // Get Address Info
  // getUserAddressInfosData: [],
  // getUserAddressInfosError: {},
  // // Get Document Type List
  // getDocumentTypeListData: [],
  // getDocumentTypeListError: {},
  // // Get Partner Clients
  // getPartnerClientsData: [],
  // getPartnerClientsError: {},
  // // Get Partner Clients
  // getPartnerTradingVolumeData: [],
  // getPartnerTradingVolumeError: {},
  // // Get Partner Clients
  // getPartnerBalanceData: [],
  // getPartnerBalanceError: {},
  // // Get PNL Share Contract Info
  // getPNLShareContractInfoData: [],
  // getPNLShareContractInfoError: {},
  // // Change Personal Password
  // changePersonalPasswordData: [],
  // changePersonalPasswordError: {},
  // // Get Sca Account Info List Withdrawal / Transfer
  // getScaAccountInfoListData: [],
  // getScaAccountInfoListError: {},
  // // Post Withdrawal Infos
  // addWithdrawalInfoData: [],
  // addWithdrawalInfoError: {},
  // // Post Withdrawal Infos
  // addInternalTransferInfoData: [],
  // addInternalTransferInfoError: {},
  // // Get Deposit Redirect Parameter
  // getDepositRedirectParameterData: [],
  // getDepositRedirectParameterError: {},
};

const SalesDashboardReducer = createSlice({
  name: "SalesDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Sales Summary Cards
    builder.addCase(
      getSalesSummaryCards.fulfilled,
      (state: any, action: any) => {
        state.salesSummaryCardsData = action.payload;
      }
    );
    builder.addCase(
      getSalesSummaryCards.rejected,
      (state: any, action: any) => {
        state.salesSummaryCardsError = action.error.message;
      }
    );
    // Get Sales Referral Link Details
    builder.addCase(
      getSalesReferralLinkDetails.fulfilled,
      (state: any, action: any) => {
        state.salesReferralLinkDetailsData = action.payload;
      }
    );
    builder.addCase(
      getSalesReferralLinkDetails.rejected,
      (state: any, action: any) => {
        state.salesReferralLinkDetailsError = action.error.message;
      }
    );
    // Add Sales Referral Link Details For Language
    builder.addCase(
      addSalesReferralLinkDetailsForLanguage.fulfilled,
      (state: any, action: any) => {
        state.addSalesReferralLinkDetailsForLanguageData = action.payload;
        state.isSalesReferralLinkDetailsForLanguageSuccess = true;
      }
    );
    builder.addCase(
      addSalesReferralLinkDetailsForLanguage.rejected,
      (state: any, action: any) => {
        state.addSalesReferralLinkDetailsForLanguageError =
          action.payload || null;
      }
    );

    // Get Sales Network Chart
    builder.addCase(
      getSalesNetworkChart.fulfilled,
      (state: any, action: any) => {
        state.getSalesNetworkChartData = action.payload;
      }
    );
    builder.addCase(
      getSalesNetworkChart.rejected,
      (state: any, action: any) => {
        state.getSalesNetworkChartError = action.error.message;
      }
    );
    // Get Sales Rebate Details
    builder.addCase(
      getSalesRebateDetails.fulfilled,
      (state: any, action: any) => {
        state.rebateSalesDetailsData = action.payload;
      }
    );
    builder.addCase(
      getSalesRebateDetails.rejected,
      (state: any, action: any) => {
        state.rebateSalesDetailsError = action.error.message;
      }
    );

    // // Post IB Onboarding Personal Info
    // builder.addCase(
    //   addIBOnboardingPersonalInfo.fulfilled,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingPersonalInfoData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   addIBOnboardingPersonalInfo.rejected,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingPersonalInfoError = action.error.message;
    //   },
    // );
    // // Post IB Onboarding Identity Verification
    // builder.addCase(
    //   addIBOnboardingIdentityVerify.fulfilled,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingIdentityVerifyData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   addIBOnboardingIdentityVerify.rejected,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingIdentityVerifyError = action.error.message;
    //   },
    // );
    // // Post IB Onboarding Address Verification
    // builder.addCase(
    //   addIBOnboardingAddressVerify.fulfilled,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingAddressVerifyData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   addIBOnboardingAddressVerify.rejected,
    //   (state: any, action: any) => {
    //     state.addIBOnboardingAddressVerifyError = action.error.message;
    //   },
    // );
    // // Get Country List
    // builder.addCase(getCountryList.fulfilled, (state: any, action: any) => {
    //   state.getCountryListData = action.payload;
    // });
    // builder.addCase(getCountryList.rejected, (state: any, action: any) => {
    //   state.getCountryListError = action.error.message;
    // });
    // // Get Country List Int2
    // builder.addCase(getCountryListInt2.fulfilled, (state: any, action: any) => {
    //   state.getCountryListInt2Data = action.payload;
    // });
    // builder.addCase(getCountryListInt2.rejected, (state: any, action: any) => {
    //   state.getCountryListInt2Error = action.error.message;
    // });
    // // Get Address Infos
    // builder.addCase(
    //   getUserAddressInfos.fulfilled,
    //   (state: any, action: any) => {
    //     state.getUserAddressInfosData = action.payload;
    //   },
    // );
    // builder.addCase(getUserAddressInfos.rejected, (state: any, action: any) => {
    //   state.getUserAddressInfosError = action.error.message;
    // });
    // // Get Document Type List
    // builder.addCase(
    //   getDocumentTypeList.fulfilled,
    //   (state: any, action: any) => {
    //     state.getDocumentTypeListData = action.payload;
    //   },
    // );
    // builder.addCase(getDocumentTypeList.rejected, (state: any, action: any) => {
    //   state.getDocumentTypeListError = action.error.message;
    // });

    // // Get Partner Clients
    // builder.addCase(getPartnerClients.fulfilled, (state: any, action: any) => {
    //   state.getPartnerClientsData = action.payload;
    // });
    // builder.addCase(getPartnerClients.rejected, (state: any, action: any) => {
    //   state.getPartnerClientsError = action.error.message;
    // });

    // // Get Partner Trading Volume
    // builder.addCase(
    //   getPartnerTradingVolume.fulfilled,
    //   (state: any, action: any) => {
    //     state.getPartnerTradingVolumeData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   getPartnerTradingVolume.rejected,
    //   (state: any, action: any) => {
    //     state.getPartnerTradingVolumeError = action.error.message;
    //   },
    // );

    // // Get Partner Balance
    // builder.addCase(getPartnerBalance.fulfilled, (state: any, action: any) => {
    //   state.getPartnerBalanceData = action.payload;
    // });
    // builder.addCase(getPartnerBalance.rejected, (state: any, action: any) => {
    //   state.getPartnerBalanceError = action.error.message;
    // });

    // // Get PNL Share Contract Info
    // builder.addCase(
    //   getPNLShareContractInfo.fulfilled,
    //   (state: any, action: any) => {
    //     state.getPNLShareContractInfoData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   getPNLShareContractInfo.rejected,
    //   (state: any, action: any) => {
    //     state.getPNLShareContractInfoError = action.error.message;
    //   },
    // );
    // // Post Change Password
    // builder.addCase(
    //   changePersonalPassword.fulfilled,
    //   (state: any, action: any) => {
    //     state.changePersonalPasswordData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   changePersonalPassword.rejected,
    //   (state: any, action: any) => {
    //     state.changePersonalPasswordError = action.error.message;
    //   },
    // );
    // // Get Sca Account Info List Withdrawal / Transfer
    // builder.addCase(
    //   getScaAccountInfoList.fulfilled,
    //   (state: any, action: any) => {
    //     state.getScaAccountInfoListData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   getScaAccountInfoList.rejected,
    //   (state: any, action: any) => {
    //     state.getScaAccountInfoListError = action.error.message;
    //   },
    // );
    // // Post Withdrawal Infos
    // builder.addCase(addWithdrawalInfo.fulfilled, (state: any, action: any) => {
    //   state.addWithdrawalInfoData = action.payload;
    // });
    // builder.addCase(addWithdrawalInfo.rejected, (state: any, action: any) => {
    //   state.addWithdrawalInfoError = action.error.message;
    // });
    // // Post Internal Transfer Infos
    // builder.addCase(
    //   addInternalTransferInfo.fulfilled,
    //   (state: any, action: any) => {
    //     state.addInternalTransferInfoData = action.payload;
    //   },
    // );
    // builder.addCase(
    //   addInternalTransferInfo.rejected,
    //   (state: any, action: any) => {
    //     state.addInternalTransferInfoError = action.error.message;
    //   },
    // );
    // // Get Deposit Redirect Parameter
    // builder.addCase(
    //   getDepositRedirectParameter.fulfilled,
    //   (state: any, action: any) => {
    //     state.getDepositRedirectParameterData = action.payload;
    //   },
    // );
    // builder
    //   .addCase(
    //     getDepositRedirectParameter.rejected,
    //     (state: any, action: any) => {
    //       state.getDepositRedirectParameterError = action.error.message;
    //     },
    //   )
    //   .addCase(clearDepositRedirectParameter.fulfilled, (state) => {
    //     state.getDepositRedirectParameterData = [];
    //   });
  },
});

export default SalesDashboardReducer.reducer;
